import React from "react";
import { Link } from "react-router-dom";
import Head from "../../components/Head";
import { fetchBudget } from "../../services/api";
import { MinistryBudgetChart } from "./ministry-budget-chart";

const toQueryString = (args) => {
  const params = new URLSearchParams();
  for (const k in args) {
    if (args[k]) {
      params.set(k, args[k]);
    }
  }
  return params.toString();
};

export class MinistryDetailPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      budgets: [],
    };
  }

  componentDidMount() {
    const { ministry } = this.props.match.params;
    fetchBudget({ ministry }).then((budgets) => {
      this.setState({
        budgets,
      });
    });
  }

  render() {
    const { ministry } = this.props.match.params;
    return (
      <div>
        <Head title={ministry} />
        <section className="section">
          <div className="container">
            <nav className="breadcrumb" style={{ overflowX: "auto" }}>
              <ul>
                <li>
                  <Link to="/">Top</Link>
                </li>
                <li>
                  <Link to="/ministries">府省庁</Link>
                </li>
                <li className="is-active">
                  <a>{ministry}</a>
                </li>
              </ul>
            </nav>
            <h1 className="title">{ministry}</h1>
            <div className="field">
              <MinistryBudgetChart ministry={ministry} />
            </div>
            <div className="field">
              <div className="control">
                <Link
                  className="button is-info"
                  to={{
                    pathname: "/projects",
                    search: toQueryString({ ministry }),
                  }}
                >
                  事業一覧を検索
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
